// Samtyckestext för hälsouppgifter i anamnesen (DPIA A3, beslut Erik 2026-11-01).
// Ändras texten: höj CONSENT_VERSION så att det framgår vilken lydelse kunden godkände.
// Versionen sparas i anamnesis_responses.consent_version.
export const CONSENT_VERSION = '2026-11-01';

export const CONSENT_TEXT =
  'Jag samtycker till att de hälsouppgifter jag lämnar här, och de anteckningar min terapeut ' +
  'gör om min behandling, behandlas av min terapeut för att behandlingen ska kunna anpassas och ' +
  'göras säker. Jag kan återkalla samtycket när som helst genom att kontakta min terapeut.';
